import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMessage = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("circle", {
			cx: 16,
			cy: 16,
			r: 16,
			fill: "#2C2C2C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.9984 9.47969C11.5887 9.47969 8.04844 12.3988 8.04844 15.9391C8.04844 17.4297 8.63848 18.7961 9.66328 19.883C9.22852 21.0941 8.26582 22.15 8.23477 22.15C8.01738 22.3674 7.98633 22.6779 8.07949 22.9574C8.20371 23.2369 8.4832 23.3922 8.79375 23.3922C10.6881 23.3922 12.1787 22.6158 13.1104 21.9637C13.9799 22.2432 14.9736 22.3984 15.9984 22.3984C20.3771 22.3984 23.9174 19.5104 23.9174 15.9391C23.9174 12.3988 20.3771 9.47969 15.9984 9.47969ZM15.9984 20.9078C15.16 20.9078 14.3215 20.7836 13.5451 20.5352L12.8309 20.3178L12.2408 20.7525C11.8061 21.0631 11.185 21.4047 10.4396 21.6531C10.6881 21.2805 10.9055 20.8457 11.0607 20.4109L11.4023 19.5414L10.7502 18.8582C10.1912 18.2682 9.53906 17.2744 9.53906 15.9391C9.53906 13.2063 12.4271 10.9703 15.9984 10.9703C19.5387 10.9703 22.4578 13.2063 22.4578 15.9391C22.4578 18.7029 19.5387 20.9078 15.9984 20.9078Z",
			fill: "white"
		})
	]
});
const ForwardRef = forwardRef(SvgMessage);
export { ForwardRef as ReactComponent };
